const languageObject = {
    button: null,
    popup: null,
    status: -1,
    initialize: function () {
        if (this.status === 1) return;
        this.status = 1;

        this.button = document.querySelector('.language-selector__container');
        this.popup = document.querySelector('.language-popup');
        this.button.addEventListener('click', this.showPopup.bind(this));
        this.popup.addEventListener('click', this.hidePopup.bind(this));
        document.querySelector('.language-popup__close-button').addEventListener('click', this.hidePopup.bind(this));
    },
    reactToResize: function () {
        this.hidePopup();
    },
    showPopup: function () {
        this.popup.classList.add('_show');
    },
    hidePopup: function () {
        this.popup.classList.remove('_show');
    }
};
